import { ErrorBoundary } from 'react-error-boundary';
import environment from '@menu-environment';
import { CachedItem } from '@self-service-core';
import ErrorPanel from 'shared/components/error-panel/error-panel';

export const retryPageLoading = (error: any) => {
  const pageHasAlreadyBeenForceRefreshed = new CachedItem('on-error', true, 86400);

  if (!pageHasAlreadyBeenForceRefreshed.isCached()) {
    pageHasAlreadyBeenForceRefreshed.set(true);
    console.error('Error boundary event-> ', error?.message);
    return window.location.reload();
  }
};

export const AppError = ({ children }: { children?: JSX.Element }) => {
  const fallBack = ({ error }: any) => <ErrorPanel error={error} showError={environment.SHOW_BOUNDARY_ERROR} />;

  return (
    <ErrorBoundary FallbackComponent={fallBack} onError={retryPageLoading}>
      {children}
    </ErrorBoundary>
  );
};